import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ThemeProvider } from '../Context/ThemeContext';
import { AuthProvider, useAuth } from '../Context/AuthContext';
import ScrollToTop from '../Components/ScrollToTop';
import AdminLayout from '../Layouts/AdminLayout';
import Dashboard from '../Pages/Admin/Dashboard';
import AdminVehicles from '../Pages/Admin/Vehicles';
import AdminServices from '../Pages/Admin/Services';
import Messages from '../Pages/Admin/Messages';
import Reviews from '../Pages/Admin/Reviews';
import Login from '../Pages/Admin/Login';
import Users from '../Pages/Admin/Users';
import AdminQuotes from '../Pages/Admin/Quotes';
 import AddVehicle from '../Pages/Admin/AddVehicle';
import BrandModelManager from '../Pages/Admin/BrandModelManager';
import SellRequests from '../Pages/Admin/SellRequests';

const ProtectedRoute = ({ children }) => {
  const { user, loading } = useAuth();
  
  if (loading) {
    return <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh', background: '#020617', color: 'white' }}>Yükleniyor...</div>;
  }
  
  if (!user || user.role !== 'admin') {
    return <Navigate to="/login" replace />;
  }
  
  return children;
};

const AppRouter = () => {
  return (
    <ThemeProvider>
      <AuthProvider>
        <Router>
          <ScrollToTop />
          <Routes>
            {/* Redirect root to admin */}
            <Route path="/" element={<Navigate to="/admin" replace />} />

            {/* Admin Login */}
            <Route path="/login" element={<Login />} />

            {/* Admin Routes (Protected) */}
            <Route path="/admin" element={<ProtectedRoute><AdminLayout /></ProtectedRoute>}>
              <Route index element={<Dashboard />} />
              <Route path="vehicles" element={<AdminVehicles />} />
              <Route path="vehicles/add" element={<AddVehicle />} />
              <Route path="vehicles/edit/:id" element={<AddVehicle />} />
              <Route path="brands-models" element={<BrandModelManager />} />
              <Route path="quotes" element={<AdminQuotes />} />
              <Route path="messages" element={<Messages />} />
               <Route path="reviews" element={<Reviews />} />
              <Route path="sell-requests" element={<SellRequests />} />
              <Route path="users" element={<Users />} />
              <Route path="services" element={<AdminServices />} />
              <Route path="settings" element={<div className="admin-card" style={{ padding: '2rem' }}><h2>Ayarlar</h2><p>Bu bölüm yakında eklenecek.</p></div>} />
            </Route>

            {/* Fallback */}
            <Route path="*" element={<Navigate to="/admin" replace />} />
          </Routes>
        </Router>
      </AuthProvider>
    </ThemeProvider>
  );
};

export default AppRouter;


